// extracted by mini-css-extract-plugin
module.exports = {"root":"Feature3_root__1eNW4","card":"Feature3_card__2wQFc","title":"Feature3_title__1ZPlv"};